import React from 'react';
import { AssetIcon } from '../../../../shared/assets';

export default function EmptyDocumentsState({
  title = 'Nessun documento trovato',
  description = '',
}) {
  return (
    <div className="documents-empty">
      <AssetIcon name="nav.documents" size={32} className="documents-empty__icon" />
      <p className="documents-empty__title">{title}</p>
      {description ? (
        <p className="documents-empty__description">{description}</p>
      ) : (
        <p className="documents-empty__description">Usa i comandi in alto a destra per creare o caricare documenti.</p>
      )}
    </div>
  );
}
